module.exports = __webpack_public_path__ + "img/elem_22.3cce13a6.svg";